import axios from "axios";

export const lookupConditions = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Lookup/conditions`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
